var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-cut -action",on:{"click":function($event){return _vm.$emit('cut')}}},[_c('span',{staticClass:"wticon wticon-scissors_V8"})])}
var staticRenderFns = []

export { render, staticRenderFns }